import React from 'react';
import PropTypes from 'prop-types';
import { Header, CBContainer } from './styled';

const GridHeader = (props) => {
  const { learningJourneyIds } = props;

  const displayCheckboxes = () => (
    learningJourneyIds.map(val => (
      <CBContainer key={val} />
    ))
  );
  return (
    <Header>
      { displayCheckboxes() }
    </Header>
  );
};

GridHeader.propTypes = {
  learningJourneyIds: PropTypes.array.isRequired
};

GridHeader.defaultProps = {
  learningJourneyIds: []
};

export default GridHeader;
